import { getCountryCallingCode } from "react-phone-number-input";
export var getCountryOptionLabel = function getCountryOptionLabel(rawLabel, country) {
  var countryCallingCode = country ? " (+".concat(getCountryCallingCode(country), ")") : "";
  return rawLabel + countryCallingCode;
};
export var isEmpty = function isEmpty(value) {
  return value.length === 0;
};